import { authHeaders, getAiServiceBaseUrl } from './service-config';

// Shared by the AI service's plain request/response endpoints (session creation,
// feedback). `chat-stream.ts` deliberately doesn't use this: it reads a streaming
// body and reports errors via callbacks instead of throwing, which this contract
// doesn't fit.
export async function postJson(path: string, body: unknown, failureLabel: string) {
  const res = await fetch(`${getAiServiceBaseUrl()}${path}`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(`Failed to ${failureLabel}: ${res.status}`);
  }
  return res.json();
}

// Returns null on 204, which the service uses for "nothing to return" rather than
// an empty body the caller would have to parse.
export async function getJson(path: string, failureLabel: string) {
  const res = await fetch(`${getAiServiceBaseUrl()}${path}`, { headers: authHeaders() });
  if (!res.ok) {
    throw new Error(`Failed to ${failureLabel}: ${res.status}`);
  }
  return res.status === 204 ? null : res.json();
}

export async function put(path: string, failureLabel: string) {
  const res = await fetch(`${getAiServiceBaseUrl()}${path}`, {
    method: 'PUT',
    headers: authHeaders(),
  });
  if (!res.ok) {
    throw new Error(`Failed to ${failureLabel}: ${res.status}`);
  }
}
